import { MenuItem, Select } from '@mui/material'
import React from 'react'

interface Props {
    label: string;
    value: string;
    onChange: (value: string) => void;
    items: string[];
    width?: string;
    height?: string;
}

export default function RoundedSelect(props: Props) {
  const controlHeight = props.height ?? '44px'

  return (
    <Select
        style={{
            width: props.width ?? '100%',
            minWidth: '100px',
            minHeight: controlHeight,
            height: controlHeight,
            borderRadius: '14px',
            backgroundColor: '#ffffff',
            color: '#132238',
        }}
        label={props.label}
        value={props.value ?? props.label}
        onChange={(e) => props.onChange(e.target.value)}
        sx={{
            color: "#132238",
            boxShadow: 'inset 0 1px 2px rgba(19, 34, 56, 0.03)',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: '#d8e0ea',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(240, 184, 0, 0.9)',
              borderWidth: '1px',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#c1ccd9',
            },
            '.MuiSvgIcon-root ': {
              fill: "#132238",
              fontSize: '1.1rem',
            },
            '&.Mui-focused': {
              boxShadow: '0 0 0 4px rgba(255, 203, 0, 0.18)',
            },
            '& .MuiOutlinedInput-input': {
              boxSizing: 'border-box',
            },
            '.MuiSelect-select': {
              display: 'flex',
              alignItems: 'center',
              boxSizing: 'border-box',
              minHeight: controlHeight,
              padding: '0 12px',
              fontSize: '0.9rem',
            },
        }}
    >
        <MenuItem value={props.label}>{props.label}</MenuItem>
        {props.items.map((item) => 
            <MenuItem value={item}>{item}</MenuItem>
        )}
    </Select>
  )
}
